import { render, staticRenderFns } from "./MaintenanceList.vue?vue&type=template&id=5afa334a"
import script from "./MaintenanceList.vue?vue&type=script&lang=js"
export * from "./MaintenanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports